import React, { useState } from "react";
import { Loader } from "../../Common";

const CollapsibleCard = ({ id, title, status, renderNode }) => {
  const [isOpen, setIsOpen] = useState(true); // Initial state is open

  const toggleCollapse = () => {
    setIsOpen(!isOpen); // Toggle collapse state
  };

  const statusContent = {
    false: <span className="legend-indicator bg-danger"></span>,
    true: <span className="legend-indicator bg-success"></span>,
    null: <Loader />,
  };

  return (
    <div className="card">
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={toggleCollapse}
        style={{
          cursor: "pointer",
          background: "var(--bs-card-border-color)",
          padding: "15px 25px 15px 25px",
          borderRadius: !isOpen ? "10px" : "10px 10px 0px 0px ",
          height: "54px",
        }}
      >
        <li className="list-inline-item d-inline-flex gap-2">
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "700",
            }}
            className="m-0"
          >
            {title}
          </h3>
          {statusContent[status]}
        </li>
        <i
          className={`bi bi-chevron-down ${isOpen ? "rotate-180" : ""}`}
          style={{ transition: "transform 0.3s ease" }}
        ></i>
      </div>
      {/* Collapsible content with keyframes */}
      <div
        style={{
          maxHeight: isOpen ? "100%" : "0px", // Use a large value to simulate auto-height
          opacity: isOpen ? 1 : 0, // Transition opacity for fade-in/fade-out effect
          overflow: "hidden", // Ensure content is hidden when collapsed
          transition: "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out", // Transition for both max-height and opacity
          animation: isOpen
            ? "expand 0.3s ease-out forwards" // Trigger the expand animation when open
            : "collapse 0.3s ease-in forwards", // Trigger the collapse animation when closed
          transformOrigin: "top", // Animation origin point
        }}
      >
        {renderNode}
      </div>
    </div>
  );
};

export default CollapsibleCard;
